import { fromJS } from "immutable";

const initMaterialData = fromJS([]);

const initFilterMaterial = fromJS({
  materialCode: "",
  materialDescription: "",
  pageNo: 1,
  pageSize: 10,
});

export function filterMaterial(state = initFilterMaterial, action) {
  switch (action.type) {
    case "FILTER_SET_MATERIAL_CODE_SUCCESS":
      return state.set("materialCode", action.materialCode);
    case "FILTER_SET_MATERIAL_DESCRIPTION_SUCCESS":
      return state.set("materialDescription", action.materialDescription);
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set("pageNo", action.pageNo);
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set("pageSize", action.pageSize);
    default:
      return state;
  }
}

export function materialData(state = initMaterialData, action) {
  switch (action.type) {
    case "MATERIAL_FETCH_DATA_SUCCESS":
      return fromJS(action.dataMaterial);
    default:
      return state;
  }
}
